module.exports = __webpack_public_path__ + "img/00-VueJS.c742f352.png";